import { useContext, useEffect } from 'react';

import CookieConsentContext from './CookieConsentContext';

const useDisableCookieConsent = (disabled = true) => {
  const [disableCookieConsent, setDisableCookieConsent] = useContext(
    CookieConsentContext
  );

  useEffect(() => {
    setDisableCookieConsent({ disableBanner: disabled });
  }, []);

  return disableCookieConsent;
};

export default useDisableCookieConsent;
